"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mandate = void 0;
var Mandate = /** @class */ (function () {
    function Mandate() {
    }
    return Mandate;
}());
exports.Mandate = Mandate;
//# sourceMappingURL=Mandate.js.map